import React, { useState } from 'react';
import api from '../../services/api';
import toast from 'react-hot-toast';

const AccountInactiveModal = ({ isOpen, onClose, email, onCloseLoginModal }) => {
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  if (!isOpen) return null;

  const handleRequestActivation = async () => {
    setLoading(true);
    try {
      const response = await api.post('/account/request-reactivation', { email });
      if (response.success) {
        setSent(true);
      } else {
        toast.error(response.message || 'Failed to send activation request. Please try again.');
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to send activation request. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setSent(false);
    // Close the login modal immediately to prevent flash
    if (onCloseLoginModal) {
      onCloseLoginModal();
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={handleClose}
      />

      {/* Modal */}
      <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 p-8 z-10">
        {/* Icon */}
        <div className="flex justify-center mb-5">
          <div className="w-16 h-16 rounded-full bg-yellow-50 flex items-center justify-center">
            <svg className="w-8 h-8 text-jet-yellow" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
          </div>
        </div>

        {sent ? (
          <>
            <h2 className="text-xl font-bold text-jet-gray-900 text-center mb-3">Request Sent</h2>
            <p className="text-jet-gray-600 text-sm text-center mb-6">
              Your activation request has been submitted. The admin will review it and get back to you shortly.
            </p>
            <button
              onClick={handleClose}
              className="w-full bg-jet-yellow text-jet-gray-900 py-3 rounded-md text-sm font-semibold hover:bg-jet-yellow-hover transition-all duration-200"
            >
              CLOSE
            </button>
          </>
        ) : (
          <>
            <h2 className="text-xl font-bold text-jet-gray-900 text-center mb-3">Account Inactive</h2>
            <p className="text-jet-gray-600 text-sm text-center mb-6">
              Your account is currently inactive. You can send a request to the admin to reactivate your account.
            </p>

            <div className="flex gap-3">
              <button
                onClick={handleClose}
                className="flex-1 border border-jet-gray-300 text-jet-gray-700 py-3 rounded-md text-sm font-semibold hover:bg-jet-gray-50 transition-all duration-200"
              >
                CANCEL
              </button>
              <button
                onClick={handleRequestActivation}
                disabled={loading}
                className="flex-1 bg-jet-yellow text-jet-gray-900 py-3 rounded-md text-sm font-semibold hover:bg-jet-yellow-hover transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'SENDING...' : 'REQUEST ACTIVATION'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AccountInactiveModal;
